export enum CP_REVIEW_CHECKLIST_TABLE_COLUMNS {
  Id = 'id',
  Name = 'Checklisten überprüfen name',
  Date = 'Datum und Uhrzeit',
  AccessLevel = 'Aktuelle Berechtigungen'
}

export enum ECP_REVIEW_CHECKLIST_ACCESS_LEVEL {
  View = 'view',
  Edit = 'edit',
  Hidden = 'hidden'
}

export interface ICPReviewChecklistItem {
  [CP_REVIEW_CHECKLIST_TABLE_COLUMNS.Id]: number
  [CP_REVIEW_CHECKLIST_TABLE_COLUMNS.Name]: string
  [CP_REVIEW_CHECKLIST_TABLE_COLUMNS.AccessLevel]: string
  [CP_REVIEW_CHECKLIST_TABLE_COLUMNS.Date]: string
}

export interface ICPReviewChecklistSetAccessLevel {
  id: number
  accessLevel: ECP_REVIEW_CHECKLIST_ACCESS_LEVEL
}

export interface ICPReviewChecklistTableDataProps {
  data: ICPReviewChecklistItem[]
  allowEdit?: boolean
  isLoading?: boolean
}
